import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Relationships::PersonRelationshipsTable @customer={{@model}} />",{ moduleName: "cio/pods/person/relationships/template.hbs" })